$(document).ready(function() {
    var checkExist = setInterval(function() {
        var $siderCont = $('.most-view-home-wrap');
        var $customNextBtn = $('.home-most-view .boost-sd__next-button');
        var $custom_prev_btn = $('.home-most-view .boost-sd__prev-button');

        if ($customNextBtn.length) {
            clearInterval(checkExist); // Stop checking once the button is found

            $customNextBtn.on('click', function() {
                if ($siderCont.length) {
                    setTimeout(function() {
                        $siderCont.addClass('cont_shown');
                    }, 100);
                }
            });
        }

        if ($custom_prev_btn.length) {
            clearInterval(checkExist); // Stop checking once the button is found

            $custom_prev_btn.on('click', function() {
                if ($siderCont.length) {
                    setTimeout(function() {
                        $siderCont.removeClass('cont_shown');
                    }, 600);
                }
            });
        }



    }, 1000); // Check every 100 milliseconds
});
